import * as React from 'react';

import { CustomersContext } from '@funnels/contexts';
import { CustomerData } from '@funnels/types';

export function useCustomers(): CustomerData[] {
  return React.useContext(CustomersContext);
}
